import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {ShapeNameFromImageModel} from '../../../../../models/questions/subModels/shapeNameFromImage.model';
import {ShapeSingleDiscriminationCountModel} from '../../../../../models/questions/subModels/shapeSingleDiscriminationCount.model';
import {EvoListSelectorService} from '../../../../../shared/modals/evo-list-selector/evo-list-selector.service';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-shape-single-discrimination-count',
  templateUrl: './evo-shape-single-discrimination-count.component.html',
  styleUrls: ['./evo-shape-single-discrimination-count.component.css']
})
export class EvoShapeSingleDiscriminationCountComponent implements OnInit {

  Enums = Enums;
  QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new ShapeSingleDiscriminationCountModel();


  constructor(private selectorSv: EvoListSelectorService) { }

  ngOnInit() {
  }

  castedQuestion(): ShapeSingleDiscriminationCountModel {

    return <ShapeSingleDiscriminationCountModel>this.question;
  }

  removeShape(index: number) {
    if (index < this.castedQuestion().model.otherShapes.length) {
      this.castedQuestion().model.otherShapes.splice(index, 1);
    }
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.shapeSingleDiscriminationCount) {
        return true;
      }
    }

    return false;
  }

  showSelector() {
    this.selectorSv.showList(Enums.Shapes.list(), this.castedQuestion().model.otherShapes).subscribe((item) => {
      if (item) {
        this.castedQuestion().model.otherShapes.push(item);
      }
    });
  }

}
